<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'HiraginoSansGB-W3','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
/*css 初始化 */
html, body, ul, li, ol, dl, dd, dt, p, h1, h2, h3, h4, h5, h6, form, fieldset, legend, img { margin:0;padding:0;}
fieldset, img,input,button { border:none;padding:0;margin:0;outline-style:none;}
ul, ol { list-style:none;}
input { padding-top:0;padding-bottom:0;font-family: "SimSun","宋体";}
select, input { vertical-align:middle;}
select, input, textarea { font-size:14px;margin:0;}
textarea { resize:none;} /*防止拖动*/
img {border:0;vertical-align:middle;}  /*  去掉图片低测默认的3像素空白缝隙*/
table { border-collapse:collapse;}
.clearfix:before,.clearfix:after{
    content:"";
    display:table;
}
html,body{width: 100%;height: 100%;}

.clearfix:after{clear:both;}
.clearfix{*zoom:1;/*IE/7/6*/  }
a{color:#666;text-decoration:none}
a:visited{color:#666}
a:hover,a:active,a:focus {color:#ff8400;text-decoration:none}
.wrap{
    width: 1200px;margin:0 auto;
}
@media screen and (max-width:980px) {
  /* .wrap{
      width: 100%;
  } */
}
</style>



// WEBPACK FOOTER //
// src/App.vue